import { axios } from '@Root/API'

export const getDynamic = () => {
	return axios.get(``)
}
